import {Component, CUSTOM_ELEMENTS_SCHEMA, ElementRef, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {ApiAgentService} from '../../../services/api-agent.service';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {NewSubAccountCountResponse} from 'src/app/models/new-sub-account-count-response';
import {NewSubAccountRequest} from '../../../models/new-sub-account-request';
import {MyBusiness} from '../../../models/my-business';
import {GlobalLoaderService} from '../../../services/global-loader.service';
import {EnvironmentService} from '../../../services/environment.service';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';

declare var $: any;
declare var Snackbar: any;

@Component({
  selector: 'app-sub-accounts-payment-form',
  templateUrl: './sub-accounts-payment-form.component.html',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, TranslateModule, RouterModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  styleUrls: ['./sub-accounts-payment-form.component.scss']
})
export class SubAccountsPaymentFormComponent implements OnInit {

  form: FormGroup;
  loading: boolean;
  @ViewChild('modalElm') modalElm: ElementRef;
  submitted: boolean;
  newSubAccountResponse: NewSubAccountCountResponse;
  newSubAccountRequest: NewSubAccountRequest;
  myBusiness: MyBusiness;

  @ViewChild('infoModal') infoModal: ElementRef;
  modalTitle: string;
  modalMsg: string;

  async showToast(msg) {
    Snackbar.show({
      text: await this.translate.get(msg).toPromise(),
      pos: 'bottom-center'
    });
  }

  showInfo(msg) {
    this.modalTitle = '';
    this.modalMsg = msg;
    $(this.infoModal.nativeElement).modal('show');
  }

  constructor(private api: ApiAgentService, private env: EnvironmentService, private formBuilder: FormBuilder, private translate: TranslateService, private loader: GlobalLoaderService) {
  }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      paymentVia: ['', [Validators.required]]
    });
  }

  // noinspection TypeScriptExplicitMemberType
  // @ts-ignore
  get f() {
    return this.form.controls;
  }

  loadData(newSubAccountResponse: NewSubAccountCountResponse): Promise<any> {
    return new Promise((resolve, reject) => {
      setTimeout(async () => {
        this.loadResources().then(() => {
          this.newSubAccountResponse = newSubAccountResponse;
          this.api.getMyBusiness(true).then(myBusiness => {
            this.myBusiness = myBusiness;
            this.api.getSubAccountRequest(this.newSubAccountResponse.approvalRequestNo).then(subAccount => {
              console.log('sub account', subAccount);
              this.newSubAccountRequest = subAccount;
              resolve(true);
            }).catch(error => {
              console.log('sub account error', error);
              reject(error);
            });
          }).catch(error => {
            console.log('error', error);
            reject(error);
          });
        });
      }, 500);
    });
  }

  openModal() {
    $(this.modalElm.nativeElement).modal('show');
  }

  private async loadResources() {
    await this.loader.loadExternalStyles('/plugins/notification/snackbar/snackbar.min.css');
    await this.loader.loadExternalScript('/plugins/notification/snackbar/snackbar.min.js');
    await this.loader.loadExternalScript('/plugins/blockui/jquery.blockUI.min.js');
  }


  submitPaymentMethod() {
    this.submitted = true;
    if (this.form.valid) {
      this.loading = true;
      this.api.postSubAccountPaymentRequest(this.newSubAccountRequest.id, this.form.value['paymentVia']).then(response => {
        if (response.paymentUrl) {
          window.top.location.href = response.paymentUrl;
        } else if (response.amountDeductedFromWallet) {
          this.showToast('Payment operation completed').then();
          setTimeout(() => {
            window.top.location.href = this.env.getDesktop() + '/private/new-sub-accounts-requests';
          }, 2000);
        }
      }).catch(response => {
        this.loading = false;
        if (response.error && response.error.title) {
          this.showInfo(response.error.title);
        } else if (response.error && response.error.detail) {
          this.showInfo(response.error.detail);
        } else {
          this.showInfo('The operation did not succeed. Please try again.');
        }
        console.log('error', response);
      });
    }
  }
}
